import { render, staticRenderFns } from "./gambit.vue?vue&type=template&id=0dc95089&scoped=true"
import script from "./gambit.vue?vue&type=script&width=true&lang=js"
export * from "./gambit.vue?vue&type=script&width=true&lang=js"
import style0 from "./gambit.vue?vue&type=style&index=0&id=0dc95089&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc95089",
  null
  
)

export default component.exports